import { render } from "./SurveyBackoffice.vue?vue&type=template&id=1633d5d8"
import script from "./SurveyBackoffice.vue?vue&type=script&lang=js"
export * from "./SurveyBackoffice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__